var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.363 9.582a.6.6 0 0 1 .6.6V12a6.97 6.97 0 0 1-2.039 4.924 6.97 6.97 0 0 1-4.325 2.012v2.155a.6.6 0 1 1-1.2 0v-2.155A6.96 6.96 0 0 1 5.037 12v-1.818a.6.6 0 1 1 1.2 0V12a5.764 5.764 0 0 0 11.527 0v-1.818a.6.6 0 0 1 .6-.6M12 2.31a3.327 3.327 0 0 1 3.327 3.327V12a3.327 3.327 0 0 1-6.654 0V5.637a3.327 3.327 0 0 1 3.327-3.327m0 1.2a2.13 2.13 0 0 0-2.128 2.127V12a2.128 2.128 0 0 0 4.255 0V5.637A2.13 2.13 0 0 0 12 3.51"
  })));
};
export default SvgMic;